import { defineComponent, computed } from 'vue-demi';
import { openBlock, createElementBlock, createElementVNode, resolveComponent, createVNode, createBlock, renderSlot } from 'vue';
import { DASHBOARD_SERVICE } from './constants/index.js';
import { useResponsive } from '@onereach/ui-components';

var script$4 = defineComponent({
  name: 'BrandLogo',
  props: {
    logoUrl: {
      type: String,
      required: true
    },
    targetUrl: {
      type: String,
      default: '/'
    }
  }
});

const _hoisted_1$4 = {
  "data-test": "brand-logo"
};
const _hoisted_2$3 = ["href", "target"];
const _hoisted_3$2 = ["src"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [createElementVNode("a", {
    href: _ctx.targetUrl,
    target: _ctx.targetUrl === '/' ? '_self' : '_blank'
  }, [createElementVNode("img", {
    src: _ctx.logoUrl
  }, null, 8 /* PROPS */, _hoisted_3$2)], 8 /* PROPS */, _hoisted_2$3)]);
}

script$4.render = render$4;
script$4.__file = "src/components/ServiceNavigationLogo/BrandLogo.vue";

var script$3 = defineComponent({
  name: 'DefaultBigLogo',
  props: {
    fill: {
      type: String,
      default: 'white'
    },
    height: {
      type: String,
      default: '16px'
    }
  }
});

const _hoisted_1$3 = ["height"];
const _hoisted_2$2 = ["fill"];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    height: _ctx.height,
    viewBox: "0 0 120 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M91.2077 0H89.4638V15.6761H91.2092V9.24736C91.2092 7.34177 92.6581 6.34779 94.2762 6.34779C96.0404 6.34779 96.8589 7.17843 96.8589 9.04494V15.6747H98.6028V9.16499C98.6028 6.08254 97.0064 4.88614 94.7375 4.88614C92.9343 4.88614 91.7124 5.76006 91.2077 6.75264V0ZM42.8648 1.17686H47.3837C50.2614 1.17686 52.6343 2.31184 52.6343 5.21141V5.29238C52.6343 7.68519 50.9757 8.86205 48.9166 9.24736L53.5164 15.6761H51.4761L47.002 9.36882H44.6883V15.6761H42.8648V1.17686ZM18.7896 5.07041H20.5335V6.74566C21.0367 5.76006 22.2557 4.88614 24.0619 4.88614C26.3307 4.88614 27.9272 6.08254 27.9272 9.16499V15.6747H26.1832V9.04493C26.1832 7.17843 25.3648 6.34779 23.6006 6.34779C21.9824 6.34779 20.5335 7.34177 20.5335 9.24736V15.6761H18.7896V5.07041ZM30.1599 10.4843V10.3223C30.1599 7.1198 32.2812 4.88614 35.3063 4.88614C37.8485 4.88614 40.2432 6.36594 40.2432 10.159V10.7076H31.966C32.0498 13.12 33.2472 14.4588 35.4958 14.4588C37.1963 14.4588 38.184 13.8501 38.4153 12.6132H40.1535C39.7746 14.7436 37.9468 15.8576 35.4683 15.8576C32.3651 15.8576 30.1599 13.7496 30.1599 10.4843ZM35.3063 6.28217C37.1168 6.28217 38.2895 7.15889 38.4573 9.35346H32.0296C32.3231 7.46322 33.4959 6.28217 35.3063 6.28217ZM50.8036 5.29238C50.8036 7.07792 49.6497 7.96999 47.5067 7.96999H44.6912V2.59524H47.5067C49.5441 2.59524 50.8036 3.24439 50.8036 5.21141V5.29238ZM54.4694 10.4843V10.3223C54.4694 7.1198 56.5922 4.88614 59.6159 4.88614C62.158 4.88614 64.5527 6.36594 64.5527 10.159V10.7076H56.2755C56.3608 13.12 57.5581 14.4588 59.8053 14.4588C61.5073 14.4588 62.4935 13.8501 62.7249 12.6132H64.4688C64.09 14.7436 62.2636 15.8576 59.7851 15.8576C56.6761 15.8576 54.4694 13.7496 54.4694 10.4843ZM59.6159 6.28217C61.4234 6.28217 62.5991 7.15889 62.7668 9.35346H56.3391C56.6385 7.46322 57.83 6.28217 59.6159 6.28217ZM66.0797 12.7347C66.0797 10.2818 68.7679 9.44979 71.5834 9.44979H73.1581V8.67917C73.1581 6.99695 72.4857 6.28217 70.8097 6.28217C69.2972 6.28217 68.457 6.89085 68.2893 8.18916H66.5425C66.7724 5.7796 68.7679 4.88614 70.8893 4.88614C73.0106 4.88614 74.9021 5.72376 74.9021 8.67778V15.6747H73.1581V14.3373C72.3397 15.3313 71.352 15.8576 69.7353 15.8576C67.6964 15.8576 66.0797 14.9055 66.0797 12.7347ZM73.1581 10.6462V11.9641C73.1581 13.6072 71.7511 14.5188 69.9031 14.5258C68.3688 14.5258 67.8237 13.8361 67.8237 12.7402C67.8237 11.1739 69.4403 10.6462 71.6456 10.6462H73.1581ZM77.0943 10.4843V10.3223C77.0943 7.07792 79.486 4.88614 82.4302 4.88614C84.7207 4.88614 86.8623 5.89966 87.2022 8.59681H85.4756C85.2037 6.91458 83.9428 6.28217 82.4302 6.28217C80.4347 6.28217 78.9018 7.81782 78.9018 10.3181V10.4843C78.9018 13.0795 80.3725 14.4588 82.4938 14.4588C84.0483 14.4588 85.4553 13.5876 85.6448 11.8635H87.2615C87.0301 14.1544 85.1199 15.8576 82.4721 15.8576C79.4051 15.8576 77.0943 13.7691 77.0943 10.4843ZM106.271 12.8743C106.271 10.4214 108.961 9.58939 111.775 9.58939H113.351V8.81878C113.351 7.13655 112.679 6.42597 110.998 6.42597C109.486 6.42597 108.646 7.03464 108.478 8.33296H106.734C106.961 5.9192 108.961 5.02574 111.082 5.02574C113.204 5.02574 115.094 5.86336 115.094 8.81738V15.8143H113.358V14.4769C112.538 15.4709 111.551 15.9972 109.934 15.9972C107.889 15.9972 106.271 15.0451 106.271 12.8743ZM113.357 10.7858V12.1037H113.351C113.351 13.7468 111.944 14.6584 110.095 14.6654C108.562 14.6654 108.015 13.9757 108.015 12.8799C108.015 11.3135 109.633 10.7858 111.839 10.7858H113.357ZM117.686 1.88326C117.686 1.26645 118.204 0.766425 118.843 0.766425C119.482 0.766425 120 1.26645 120 1.88326C120 2.50006 119.482 3.00009 118.843 3.00009C118.204 3.00009 117.686 2.50006 117.686 1.88326ZM119.737 5.21002H118.002V15.8199H119.737V5.21002ZM101.466 14.8832C101.466 14.2664 101.984 13.7663 102.623 13.7663C103.262 13.7663 103.78 14.2664 103.78 14.8832C103.78 15.5 103.262 16 102.623 16C101.986 15.9954 101.471 15.4981 101.466 14.8832ZM9.49726 1.06099C12.6875 1.44926 15.2785 3.73538 15.9654 6.768C17.0485 11.5871 13.257 15.8841 8.45176 15.8618H5.5293H0.109504C0.0739654 15.8626 0.0403355 15.8463 0.0197561 15.8183C-0.000823273 15.7903 -0.0056654 15.7543 0.00683403 15.7222L0.151439 15.3871C0.18679 15.3083 0.228879 15.2141 0.272392 15.1167C0.37839 14.8795 0.492846 14.6234 0.53898 14.5244C0.552605 14.4939 0.584132 14.4745 0.618513 14.4755H3.21273C3.41454 14.4755 4.34296 14.4791 5.34733 14.4829C6.53067 14.4874 7.81946 14.4923 8.14954 14.4923C11.3771 14.4895 13.9352 12.2754 14.2692 8.97234C14.6033 5.66931 12.2751 2.7488 9.06344 2.44726C5.85176 2.14571 2.70082 4.60693 2.38848 7.91694C2.34587 8.34463 2.35509 8.77566 2.41595 9.20129C2.42352 9.23612 2.4141 9.27237 2.39039 9.29962C2.36668 9.32686 2.33132 9.34208 2.29448 9.34089H0.972795C0.905833 9.34083 0.849119 9.29322 0.839758 9.22921C0.792261 8.89332 0.768587 8.55469 0.768902 8.21569C0.750103 3.78326 4.78747 0.502574 9.49726 1.06099Z",
    fill: _ctx.fill
  }, null, 8 /* PROPS */, _hoisted_2$2)], 8 /* PROPS */, _hoisted_1$3);
}

script$3.render = render$3;
script$3.__file = "src/components/ServiceNavigationLogo/DefaultBigLogo.vue";

var script$2 = defineComponent({
  name: 'DefaultSmallLogo',
  props: {
    fill: {
      type: String,
      default: 'white'
    },
    height: {
      type: String,
      default: '16px'
    }
  }
});

const _hoisted_1$2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("rect", {
  width: "24",
  height: "24",
  fill: "white",
  "fill-opacity": "0.01"
}, null, -1 /* HOISTED */);
const _hoisted_3$1 = ["fill"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$2, [_hoisted_2$1, createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14.1122 0.735048C18.8526 1.33255 22.7027 4.85058 23.7234 9.51738C25.3328 16.9334 19.6988 23.5459 12.5587 23.5115H8.2161H0.162714C0.109907 23.5128 0.0599354 23.4877 0.029356 23.4446C-0.00122332 23.4016 -0.00841834 23.3461 0.0101548 23.2967L0.225026 22.7811C0.277541 22.6598 0.340059 22.5149 0.404696 22.3651C0.562218 22 0.732322 21.6058 0.800882 21.4534C0.821127 21.4065 0.867974 21.3767 0.919061 21.3783H4.77386C5.07326 21.3783 6.44886 21.3837 7.93851 21.3895L7.9457 21.3896L7.94817 21.3896L7.95005 21.3896C9.70722 21.3965 11.6195 21.404 12.1096 21.404C16.9055 21.3997 20.7066 17.9925 21.2029 12.9096C21.6993 7.82665 18.2399 3.33237 13.4676 2.86833C8.69526 2.40429 4.01321 6.19178 3.54909 11.2854C3.48577 11.9436 3.49947 12.6069 3.58991 13.2619C3.60116 13.3155 3.58716 13.3713 3.55193 13.4132C3.5167 13.4551 3.46416 13.4786 3.40942 13.4767H1.4455C1.346 13.4766 1.26172 13.4034 1.24781 13.3049C1.17724 12.788 1.14206 12.2669 1.14253 11.7452C1.11459 4.92427 7.11381 -0.12428 14.1122 0.735048ZM8.24 13.7596C8.90274 13.7596 9.44 13.2224 9.44 12.5596C9.44 11.8969 8.90274 11.3596 8.24 11.3596C7.57726 11.3596 7.04 11.8969 7.04 12.5596C7.04 13.2224 7.57726 13.7596 8.24 13.7596ZM13.44 12.5596C13.44 13.2224 12.9027 13.7596 12.24 13.7596C11.5773 13.7596 11.04 13.2224 11.04 12.5596C11.04 11.8969 11.5773 11.3596 12.24 11.3596C12.9027 11.3596 13.44 11.8969 13.44 12.5596ZM16.24 13.7596C16.9027 13.7596 17.44 13.2224 17.44 12.5596C17.44 11.8969 16.9027 11.3596 16.24 11.3596C15.5773 11.3596 15.04 11.8969 15.04 12.5596C15.04 13.2224 15.5773 13.7596 16.24 13.7596Z",
    fill: _ctx.fill
  }, null, 8 /* PROPS */, _hoisted_3$1)]);
}

script$2.render = render$2;
script$2.__file = "src/components/ServiceNavigationLogo/DefaultSmallLogo.vue";

var script$1 = defineComponent({
  name: 'DefaultLogo',
  components: {
    DefaultBigLogo: script$3,
    DefaultSmallLogo: script$2
  },
  props: {
    target: {
      type: String,
      default: '/'
    },
    service: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      isDesktop
    } = useResponsive();
    const linkAttribute = computed(() => {
      return props.service === DASHBOARD_SERVICE ? '_self' : '_blank';
    });
    return {
      isDesktop,
      linkAttribute
    };
  }
});

const _hoisted_1$1 = {
  "data-test": "default-logo"
};
const _hoisted_2 = ["href", "target"];
const _hoisted_3 = ["href", "target"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_default_big_logo = resolveComponent("default-big-logo");
  const _component_default_small_logo = resolveComponent("default-small-logo");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [_ctx.isDesktop ? (openBlock(), createElementBlock("a", {
    key: 0,
    href: _ctx.target,
    target: _ctx.linkAttribute
  }, [createVNode(_component_default_big_logo)], 8 /* PROPS */, _hoisted_2)) : (openBlock(), createElementBlock("a", {
    key: 1,
    href: _ctx.target,
    target: _ctx.linkAttribute
  }, [createVNode(_component_default_small_logo)], 8 /* PROPS */, _hoisted_3))]);
}

script$1.render = render$1;
script$1.__file = "src/components/ServiceNavigationLogo/DefaultLogo.vue";

var script = defineComponent({
  components: {
    BrandLogo: script$4,
    DefaultLogo: script$1
  },
  props: {
    logoUrl: {
      type: String,
      default: undefined
    },
    targetUrl: {
      type: String,
      default: undefined
    },
    service: {
      type: String,
      required: true
    }
  }
});

const _hoisted_1 = {
  "data-test": "logo",
  class: "layout-row md:min-w-[120px]"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BrandLogo = resolveComponent("BrandLogo");
  const _component_DefaultLogo = resolveComponent("DefaultLogo");
  return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.logoUrl ? (openBlock(), createBlock(_component_BrandLogo, {
    key: 0,
    "logo-url": _ctx.logoUrl,
    "target-url": '/'
  }, null, 8 /* PROPS */, ["logo-url"])) : renderSlot(_ctx.$slots, "default", {
    key: 1
  }, () => [createVNode(_component_DefaultLogo, {
    service: _ctx.service,
    "target-url": _ctx.targetUrl
  }, null, 8 /* PROPS */, ["service", "target-url"])])]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationLogo/ServiceNavigationLogo.vue";

export { script as s };
